module.exports = __webpack_public_path__ + "img/footer.8c568822.png";